/**
 * Display modes that are not part of the base bundle register themselves here.
 *
 * The base entry (`widget.js`) ships only the plain form; the projects entry
 * (`widget-projects.js`) additionally imports `picker/register.js`, which
 * registers the ProjectPicker and ItemPicker modes. A mode brings its own root
 * component, its own host payload reader and its own CSS, so the base graph
 * never imports any of it.
 */
const modes = new Map();

export function registerDisplayMode(name, mode) {
  modes.set(name, mode);
}

export function getDisplayMode(name) {
  return (name && modes.get(name)) || null;
}

export function collectDevCss() {
  return Array.from(new Set(Array.from(modes.values(), mode => mode.devCss))).filter(Boolean).join('\n');
}
